<form [formGroup]="detailsForm">
    <div class="form-group row">
        <div class="col s12 col-inline-content">
            <app-input-switch
                class="switch"
                tooltipText="{{'admin.lines.create-modal.insertion-cycles.tooltips.isSpi'
                        | translate}}"
                [formControl]="detailsForm.controls.isSPI"
                [disabled]="isEditMode && line && line.isSPI"
                [inline]="true"
                offLabel="{{
                    'admin.lines.create-modal.insertion-cycles.isSPI-input.label'
                        | translate
                }}">
            </app-input-switch>
        </div>
    </div>
    <div class="form-group row">
        <div class="col s6">
            <app-input
                [formControl]="detailsForm.controls.name"
                [showErrors]="showValidations"
                placeholder="{{
                    'admin.lines.create-modal.details.name-input.placeholder'
                        | translate
                }}"
                label="{{
                    'admin.lines.create-modal.details.name-input.label'
                        | translate
                }}"
            >
            </app-input>
        </div>
        <div class="col s6">
            <app-dropdown-autocomplete
                [formControl]="detailsForm.controls.plant"
                [showErrors]="showValidations"
                [items]="plants"
                name="plant"
                valueField="id"
                displayField="name"
                [label]="
                    'admin.lines.create-modal.details.plant-input.label'
                        | translate
                "
                [emptyText]="
                    'admin.lines.create-modal.details.plant-input.placeholder'
                        | translate
                "
            >
            </app-dropdown-autocomplete>
        </div>
    </div>
    <div class="form-group row">
        <div class="col s6">
            <app-input
                [formControl]="detailsForm.controls.mesId"
                [showErrors]="showValidations"
                placeholder="{{
                    'admin.lines.create-modal.details.mesId-input.placeholder'
                        | translate
                }}"
                label="{{
                    'admin.lines.create-modal.details.mesId-input.label'
                        | translate
                }}"
            >
            </app-input>
        </div>
        <div class="col s6">
            <app-input
                [formControl]="detailsForm.controls.toolRequestsLimit"
                [showErrors]="showValidations"
                type="number"
                placeholder="{{
                    'admin.lines.create-modal.details.tool-requests-limit.placeholder'
                        | translate
                }}"
                label="{{
                    'admin.lines.create-modal.details.tool-requests-limit.label'
                        | translate
                }}"
            >
            </app-input>
        </div>
    </div>
    <div class="row">
        <div class="col s12">
            <app-textarea
                [formControl]="detailsForm.controls.description"
                [showErrors]="showValidations"
                placeholder="{{
                    'admin.lines.create-modal.details.description-input.placeholder'
                        | translate
                }}"
                label="{{
                    'admin.lines.create-modal.details.description-input.label'
                        | translate
                }}"
            >
            </app-textarea>
        </div>
    </div>
    <div class="form-group row">
        <div class="col s6">
            <app-input
                type="email"
                [formControl]="detailsForm.controls.contactEmailAddress"
                [showErrors]="showValidations"
                placeholder="{{
                    'admin.lines.create-modal.details.contact-email-input.placeholder'
                        | translate
                }}"
                label="{{
                    'admin.lines.create-modal.details.contact-email-input.label'
                        | translate
                }}">
            </app-input>
        </div>
    </div>
</form>
